"use client";

import { useState } from "react";
import { Circle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function PortfolioOverview() {
  const [activeFilter, setActiveFilter] = useState("All");
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const filters = ["All", "Residential Projects", "Commercial & Corporate Projects"];
  const projects = [{
    id: 1,
    image: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-thumb.jpg",
    category: "Residential Projects"
  }, {
    id: 2,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-Apartment-Building-Renovation.jpg?v=tk99gsrxjs",
    category: "Residential Projects"
  }, {
    id: 3,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Leukothea-Office-Construction.jpg?v=7cprtkqy105",
    category: "Commercial & Corporate Projects"
  }, {
    id: 5,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Ekali-Bathroom-Renovation.jpg?v=ryoh948np8",
    category: "Residential Projects"
  }, {
    id: 6,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Pareklisia-Residence-Renovation.jpg?v=nrdcjzx3s8",
    category: "Residential Projects"
  }, {
    id: 7,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Agios-Nikolaos-Residence-Renovation.jpg?v=c82t10us3be",
    category: "Residential Projects"
  }, {
    id: 8,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Agios-Nikolaos-Full-House-Renovation.jpg?v=k1xzd5oipxk",
    category: "Residential Projects"
  }];
  const filteredProjects = activeFilter === "All" ? projects : projects.filter(project => project.category === activeFilter);
  return <section id="portfolio-overview" className="w-full bg-primary ![padding:0px_0px_96px_0px]">
      <div className="mx-auto max-w-7xl ![padding:5px_32px_0px_32px]">
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        </div>

        <div className={`mb-12 flex flex-wrap items-center justify-center gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          {filters.map((filter, i) => <Button key={filter} data-index={i} onClick={() => setActiveFilter(filter)} className={`inline-flex items-center gap-2 rounded-full px-6 py-3 font-sans text-base font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${activeFilter === filter ? "bg-accent text-foreground-accent shadow-medium hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5" : "border border-border bg-light-background text-foreground-primary shadow-soft hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5"}`}>
              <Circle className={`h-2 w-2 fill-current ${activeFilter === filter ? "text-foreground-accent" : "text-foreground-primary"}`} />
              {filter}
            </Button>)}
        </div>

        <div ref={gridRef} className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filteredProjects.map((project, i) => <div key={project.id} data-index={i} className={`group overflow-hidden rounded-xl border-l border-r border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:scale-[1.04] hover:shadow-medium ${gridVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: gridVisible ? `${i * 50}ms` : "0ms"
        }}>
              {i === 0 ? <Link to="https://theksway.com/palodia-residence-renovation/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Palodia Residence<br></br> Renovation
                    </div>
                  </div>
                </Link> : i === 1 ? <Link to="https://ksluxury.cloudtech.com.cy/anexartisias-apartment-building-renovation-3/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Anexartisias Apartment Building Renovation
                    </div>
                  </div>
                </Link> : i === 3 ? <Link to="https://ksluxury.cloudtech.com.cy/ekali-bathroom-renovation-3/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Ekali Bathroom <br></br>Renovation
                    </div>
                  </div>
                </Link> : i === 4 ? <Link to="https://ksluxury.cloudtech.com.cy/pareklisia-residence-renovation-2/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Pareklisia Residence Renovation
                    </div>
                  </div>
                </Link> : i === 5 ? <Link to="https://ksluxury.cloudtech.com.cy/agios-nikolaos-residence-renovation-2/"> 
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                     <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Agios Nikolaos Residence Renovation
                    </div>
                  </div>
                </Link> : i === 2 ? <Link to="https://ksluxury.cloudtech.com.cy/leukothea-office-construction-2/">
                  <div className="relative group/portfolio-item">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                   <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      <span className="text-white text-2xl font-bold">Leukothea Office Construction</span>
                    </div>
                  </div>
                </Link> : i === 6 ? <Link to="https://ksluxury.cloudtech.com.cy/agios-nikolaos-full-house-renovation-2/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                   <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Agios Nikolaos Full House Renovation
                    </div>
                  </div>
                </Link> : <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />}
                </div>)}
        </div>
      </div>
    </section>;
}